module.exports = "/_next/static/images/b62e2e6ee1deb45e3a766299a1d1c195-device-frame-dark@3x.png.webp";